import { useSWRConfig, unstable_serialize } from 'swr';

export function useMatchMutate() {
  const { cache, mutate } = useSWRConfig();

  return (identifier: string | unknown[]) => {
    if (!(cache instanceof Map)) {
      throw new Error('matchMutate requires the cache provider to be a Map instance');
    }

    const keys: string[] = [];

    switch (true) {
      case Array.isArray(identifier): {
        const serializedKey = unstable_serialize(identifier);

        if (cache.has(serializedKey)) {
          keys.push(serializedKey);
        }
        break;
      }
      case typeof identifier === 'string': {
        const matcher = new RegExp(identifier);

        // eslint-disable-next-line no-restricted-syntax
        for (const key of cache.keys()) {
          if (matcher.test(key)) {
            keys.push(key);
          }
        }
        break;
      }
      default:
        throw new Error('matchMutate only accepts a string (for regex pattern matching) or an array key.');
    }

    const mutations = keys.map((key) => mutate(key));

    return Promise.all(mutations);
  };
}

export type MatchMutate = ReturnType<typeof useMatchMutate>;
